import { ToastContainer } from 'react-toastify';
import { DevedorProvider } from './context/ConsultContext';
import { DashboardContextProvider } from './context/context/DashboardContext';
import { NegocioContextProvider } from './context/context/DetalhamentoNegocioContext';
import { PainelProcessamentoProvider } from './context/context/PainelProcessaementoContext';
import { TableProvider } from './context/TableContext';
import { HeaderFilterProvider } from './hooks/hooks/useHeaderFilter';
import { SelectComponentProvider } from './hooks/hooks/useSelectComponent';
import { Router } from './routes/routes';

import { GlobalStyle } from './styles/global';
import 'react-toastify/dist/ReactToastify.css';
import { UsersProvider } from './context/UserContext';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';


function App() {
  return (
    <>
      <UsersProvider>
        <SelectComponentProvider>
          <DashboardContextProvider>
            <NegocioContextProvider>
              <PainelProcessamentoProvider>
                <HeaderFilterProvider>
                  <DevedorProvider>
                    <TableProvider>
                      <ToastContainer autoClose={3000} />
                      <Router />
                      <ThemeProvider theme={theme}>
                        <GlobalStyle />
                      </ThemeProvider>
                    </TableProvider>
                  </DevedorProvider>
                </HeaderFilterProvider>
              </PainelProcessamentoProvider>
            </NegocioContextProvider>
          </DashboardContextProvider>
        </SelectComponentProvider>
      </UsersProvider>
    </>
  );
}

export default App;
